<script>
	import { cn } from "./cn.js";
	let className = "";
	export { className as class };
</script>

<label class={cn("tw-text-sm tw-font-medium tw-text-foreground", className)} {...$$restProps}>
	<slot />
</label>
